export { default } from "./CoveoSearchBox";
export { rehydrator } from "./CoveoSearchBox.rehydrator";